<template>
    <div class="g-container" style="background: #f5f7fa;">
        <div class="m-norm-banner" style="width:100%;padding-top: 0px;" v-for="item in cases.tags" v-if="item.id == currentTagId">
            <div class="pic-banner">
                <img :src="item.BgImgUrl" v-if="item.BgImgUrl != null" alt>
                <img :src="cases.picPath" v-else alt>
            </div>
            <div class="pos_Ra" v-if="item.Desc != null">
                <i class="font_banner" >{{item.Desc}}</i>
            </div>
            
        </div>
        
        <left-menu :lists="cases.tags" :fixationDir="fixationDir" :currentTagId="currentTagId" @filterTag="filterTag"></left-menu>
        <div class="m-container m-width" style="width: 1170px;">
            <!--面包屑-->
            <div class="coursewares">
                <i style="margin-top: 7px;margin-right: 8px;" class="log keJ"></i>
                <span class="kejian1">{{tagName}}课件</span>
                <div class="maBot55 dis_inline_block" style="display: flow-root;">
                    <div class="videoimgss maTop20" v-for="(item,index) in list" :key="index" style="margin-top: 15px;">
                        <i class="bofangss" @click="openPopVideo(item.Id,item.VideoUrl)" :id="'play_'+index" :data-playId ="item.Id"></i>
                        <img class="tups" :src="item.VideoBgUrl" :id="'Bgimg_'+index">
                        <video :src="item.VideoUrl" :data-src="item.VideoUrl" width="100%" :data-playId ="item.Id" :data-index="index" class="videoss myVideo" style="visibility: hidden"></video>
                        <i class="makes"></i>
                        <span class="te_d">{{item.Title}}</span>
                        <!--@click="openPopVideo(item.Id,item.VideoUrl)"-->
                        <i class="FDaimg" >
                            <i class="FDa"></i>
                        </i>
                    </div>
                </div>
            </div>
            <div class="cours">
                <i style="margin-top: 7px;margin-right: 8px;"class="log anL"></i>
                <span class="kejian1">{{tagName}}课件案例</span>
                
            </div>
            <!--详情-->
            <!--参考 https://hao.uisdc.com/#inspiration-->
            <div class="m-cases-content">
                <div>
                    <div class="b"><product-item v-for="(item,index) in filterList" :key="index" :info="item"></product-item> </div>
                </div>
            </div>
        </div>
        <!--视频弹框 显示 +show-->
		<div class="shadow-fixed show" v-show="popVideoDir">
			<div class="mask">
			<div class="mask_top" >
				<div class="bomb-small-close"  @click="closePopVideo"></div>
				<div class="bomb-video-box">
					<video style="width:100%;height:100%;object-fit: fill;" ref="popVideo" class="video-area" autoplay controls="true"></video>
					<!--播放按钮 显示 +show-->
					<i class="video-icon"></i>
				</div>
			</div>
			</div>
		</div>
    </div>
</template> 

<script>
import '../../../../html/components/slideBar/slideBar.scss';
import '../../../../html/components/cases/cases.scss';
import '../../../../html/pages/cases/cases/cases.scss';

import {getCaseDetail, getCasesInex, getNewsIndex,Common,playNum} from '../../../../api/index';

import leftMenu from './components/left-menu/left-menu';
import productItem from './components/product-item/product-item';
export default {
    name: 'cases-index',
    components: {
        leftMenu,
        productItem
    },
    data() {
        return {
            cases: {},
            currentTagId: undefined,
            fixationDir: false,
            list: [],
            popVideoDir:false,
            tagName:''
        };
    },
    computed: {
        filterList() {
            if (this.currentTagId == undefined) {
                return this.cases.alk;
            } else {
                return this.cases.alk.filter(item => {
                    return item.tagId == this.currentTagId;
                });
            }
        }
    },
    methods: {
        closePopVideo() {
            this.$refs.popVideo.pause();
            this.popVideoDir = false;
        },
        openPopVideo(id,url){
            this.$refs.popVideo.src = url;
            this.$refs.popVideo.play();
            this.popVideoDir = true;
        },
        async Common() {
            var _this = this
            let res = await Common({
                tagId: this.currentTagId
            });
            if (res.Type == 'Success') {
                this.list = res.Data;
                for(let val of this.list){
                    if(val.VideoUrl.indexOf('https') == -1){
                            val.VideoUrl = 'https://www.iduilv.com'+val.VideoUrl;
                    }

                }
                this.uesrRole = res.Data.CanOperat;
            }
        },
        videos(index){
            let myVideoList = document.getElementsByClassName('myVideo');
            myVideoList[index].play(); //播放视频
            let play_id = document.getElementById('play_'+index);
            play_id.style.display = "none";
            let Bgimg_id = document.getElementById('Bgimg_'+index);
            Bgimg_id.style.display = "none"
            let data = {
                id:myVideoList[index].getAttribute('data-playId'),
            }
            let  res =  playNum(data);
            this.addPlayNum(index)
        },
        // 增加播放量
			addPlayNum(index){
				let that = this;
				let myVideoList = document.getElementsByClassName('myVideo');
				for(let val of myVideoList){
					let data = {
						id:val.getAttribute('data-playId'),
					}
                    val.addEventListener('ended',function(){
                        let play_id = document.getElementById('play_'+index);
                        play_id.style.display = "block";
                        let Bgimg_id = document.getElementById('Bgimg_'+index);
                        Bgimg_id.style.display = "block"

                    })
				} 
				
			},
        async init() {
            let res = await getCasesInex();
            this.cases = res.Data;
            this.currentTagId = this.cases.tags[0].id;
            this.tagName = this.cases.tags[0].tagName;
            this.Common(this.currentTagId);
            // console.log(res);
        },
        filterTag(id,tagName) {
            // let offsetTop = document.querySelector('#leftTabMenu').offsetTop;
            // document.documentElement.scrollTop = 352;
            this.fixationDir = true;
            this.currentTagId = id;
            this.tagName = tagName
            this.Common();
            // console.log(id)
            // this.$router.push('/cases/index?tagId=' + id);
        },
        handleScroll() {
            this.$nextTick(() => {
                setTimeout(() => {
                    let scrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop;
                    let offsetTop = document.querySelector('#leftTabMenu').offsetTop;
                    if (scrollTop >= 352) {
                        this.fixationDir = true;
                    } else {
                        this.fixationDir = false;
                    }
                });
            });
        }
    },
    created() {
        this.init();
        
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style scoped>

.videoimgss .videoss {
    width: 218px;
    height: 160px;
    object-fit: fill;
    border-radius: 6px;
}
.tups{
    width: 218px;
    height: 160px;
    position: absolute;
    z-index: 1;
    border-radius: 6px;
}
.coursewares{
    margin-top: 64px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    line-height: 36px;
}
.m-cases-content{
padding-left: 0;
min-height:660px;
padding-bottom: 90px;
}

.b{
position: relative;
width: 100%;
height: 100%;
}
.m-slide-left{width: initial; margin-top: -27px;}
</style>
